import './abstract_section_view.coffee'
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.NetworkIssuesView extends Monitoring.Reports.Executive.AbstractSectionView
  id: 'network'
  name: 'network'
  tagName: 'section'
  template: JST["backbone/templates/monitoring/reports/executive/network"]

  initialize: (@options = {}) ->
    @colors = {}
    @colors[@options.settings.accountLabel.codes[0]] = @options.settings.accountLabel.color
    $.each @options.settings.competitorsLabels, (index, label) =>
      @colors[label.codes[0]] = label.color

  render: ->
    @$el.html(@template(
      issues:@options.settings.networkIssuesTags
      brands: (key for key of @colors)
    ))

    pending_charts = 0
    for issue in @options.settings.networkIssuesTags
      id = issue.name.toLowerCase().replace(/\s/g, '-')
      pending_charts += 1
      @addCategoryHistogram(id, issue)

    @bindChartsReady(pending_charts)
    return this

  addCategoryHistogram: (divId, issue)->
    query = @extendedQuery(
      dimension: 'filtered_labels'
      tags: issue.tag_list
      labels: @labelFilter()
      labels_structure: @labelsStructure()
      offset: '-3h'
    )
    @_addHistogram(query, "#bar-chart-#{divId}", { drillDownFunction: (clickEvent) =>
      from = new Date(clickEvent.point.x)
      to = new Date(clickEvent.point.x + clickEvent.point.series.pointInterval)
      {
        date_from: @_formatDate(from)
        date_from_ISO: from.toISOString()
        date_to: @_formatDate(to)
        date_to_ISO: to.toISOString()
        labels: [clickEvent.point.series.name]
        tags: issue.tag_list
      }
    } )
